
namespace TabAurous.Common {

    @Serenity.Decorators.registerClass()
    export class ProductSKUSelectGrid extends _Ext.GridBase<OMS.ProductPartyDetailsRow, any> {
        protected getColumnsKey() { return 'OMS.ProductPartyDetails'; }
        protected getDialogType() { return <any>OMS.ProductPartyDetailsDialog; }
        protected getIdProperty() { return OMS.ProductPartyDetailsRow.idProperty; }
        protected getLocalTextPrefix() { return OMS.ProductPartyDetailsRow.localTextPrefix; }
        protected getService() { return OMS.ProductPartyDetailsService.baseUrl; }

        constructor(container: JQuery, options: any) {
            super(container, options);
            var customerid = options.GridFilters.CustomerId;
            (this.view.params as TransactionRequest).PartyId = customerid;
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);

            new Serenity.HeaderFiltersMixin({
                grid: this
            });

            return this;
        }

        private autoSize;

        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize(); // *** If you want to make it autoresize when grid is loaded, use: new Slick.AutoColumnSize(true);
            grid.registerPlugin(this.autoSize);



            return grid;
        }

        protected createToolbarExtensions(): void {
            super.createToolbarExtensions()

        }
        protected getViewOptions() {
            var opt = super.getViewOptions();
            opt.rowsPerPage = 20;
            return opt;
        }
        // *** Resizes the columns after changes are made to the grid (ex. Column Picker) *
        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }

        get selectedItems(): OMS.ProductPartyDetailsRow[] {
            var _this = this;
            return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
        }

        protected usePager() { return true; };
        protected getInitialTitle() { return null; };

        protected getButtons() {
            var buttons = super.getButtons.call(this);
            buttons = buttons.filter(function (x) { return x.cssClass != 'add-button'; });
            return buttons;
        };

        protected onViewSubmit() {
            if (!super.onViewSubmit.call(this))
                return false;

            //var request = this.view.params;
            //if (this.options.hideProducts && this.options.hideProducts.length)
            //    request.Criteria = Serenity.Criteria.and(request.Criteria, [["ProductID" /* ProductID */], 'not in', [this.options.hideProducts]]);
            return true;

        }

    }
}